import { inject, observer } from 'mobx-react';
import { ReactComponent as CloseIcon } from '../../svg/close.svg'
import React from 'react'

@inject('templateStore', 'photoStore', 'store', 'illustrationStore', 'elementStore', 'workAreaStore', 'sidebarStore') @observer
class SlideMenu extends React.Component{

  getActiveItem(){
    const activeSlide = this.props.sidebarStore.items.find(({ active }) => active)
    return activeSlide
  }

  sortBySelection(){
    return true
  }

  closeMenu(){
    this.props.workAreaStore.toggleFontSelect(false)
    if(this.props.sidebarStore.fullScreen){
      this.toggleFull()
    }
    const item = this.getActiveItem()
    if(item && item.id === 'templates' && this.props.templateStore && this.props.templateStore.keyword && this.props.templateStore.keyword.length){
      this.props.templateStore.populateUserDesigns('')
      if(this.props.store.isTeam){
        this.props.templateStore.populateUserDesigns('', this.props.store.teamDetails._id)
      }
    }
    if(item && item.id === 'gifs' && this.props.elementStore.searchQuery.length){
      this.props.elementStore.searchByTerm('')
    }
    if(item && item.id === 'photos' && this.props.photoStore.searchTerm.length){
      this.props.photoStore.setTerm('')
      this.props.photoStore.searchImages()
    }
    if(item && item.id === 'illustrations'){
      this.props.illustrationStore.setSelectedCollection(null, true)
    }
    this.props.sidebarStore.closeSidebarSlide()
    this.props.workAreaStore.setHidden(false)
  }

  toggleFull(){
    if(this.props.sidebarStore.fullScreen){
      this.props.workAreaStore.setHidden(false)
    }else{
      this.props.workAreaStore.setHidden(true)
    }
    this.props.sidebarStore.toggleFullscreen()
    setTimeout(() => {
      this.props.workAreaStore.setPageCenter(false, true)
    }, 0)
  }

  render(){
    const data = this.getActiveItem()
    if(!data){
      return <div />
    }
    const className = data.id === 'color-picker' || data.id === 'filters' || data.id === 'color-picker-page' || data.id === 'svg-color-picker' ? 'slide-menu picker' : 'slide-menu'
    const [pillOne, pillTwo] = data.pills
    const hasTitle = !pillOne && !pillTwo && data.subtitle && !data.searchable
    const { illustrationStore: ils } = this.props
    const showTitle = data.id === 'illustrations' && ils.selectedCollection && !ils.collectionsOnly
    return (
      <div className={className}>
        {
          hasTitle || showTitle ? (
            <h5 className='slide-menu__text-title'>
              {data.subtitle}
            </h5>
          )
          :
          undefined
        }
        <div className="slide-menu__close">
          <span onClick={() => this.closeMenu()} className='slide-menu__close__icon'>
            <CloseIcon />
          </span>
        </div>
      </div>
    )
  }

}

export default SlideMenu